import { Autocomplete, Popper, PopperProps, TextField } from "@mui/material";

type Option = {
  label: string;
  id: number;
};

type Props = {
  options: Option[];
  onSelect: (id: number | null) => void; // 単一選択時
  onSelectMultiple?: (ids: number[]) => void; // 複数選択時
  sx?: any;
  labelFontSize?: string;
  value?: number | null; // 単一選択の値
  values?: number[]; // 複数選択の値
  isMultiple?: boolean; // 単一 or 複数選択フラグ
  isDisabled?: boolean;
};

const BaseFilterSelect = ({
  options,
  onSelect,
  onSelectMultiple,
  sx,
  labelFontSize = "1.0rem",
  value,
  values = [],
  isMultiple = false,
  isDisabled = false,
}: Props) => {
  const CustomPopper = (props: PopperProps) => (
    <Popper
      {...props}
      style={{
        ...props.style,
        width: props.anchorEl
          ? (props.anchorEl as HTMLElement).clientWidth
          : undefined,
        zIndex: 4000,
      }}
      placement="bottom-start"
    />
  );

  return (
    <Autocomplete
      multiple={isMultiple}
      options={options}
      getOptionLabel={(option) => option.label}
      value={
        isMultiple
          ? options.filter((opt) => values.includes(opt.id))
          : options.find((opt) => opt.id === value) || null
      }
      onChange={(_, selected) => {
        if (isMultiple && Array.isArray(selected)) {
          onSelectMultiple?.(selected.map((s) => s.id));
        } else {
          const selectedOption = selected as Option | null;
          onSelect(selectedOption ? selectedOption.id : null);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="拠点を検索"
          variant="outlined"
          size="small"
          InputLabelProps={{
            sx: { fontSize: labelFontSize },
          }}
          disabled={isDisabled}
        />
      )}
      PopperComponent={CustomPopper}
      fullWidth
      clearOnEscape
      sx={sx}
      disabled={isDisabled}
    />
  );
};

export default BaseFilterSelect;
